/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getSelectedProductIdFromActionInput } from './get-supersession-products.action';
import { getDescriptionByProductIdAsync } from './DataActionExtension.g';

/**
 * GetEnhancedDescription Input Action
 */
export class GetEnhancedDescriptionInput implements Msdyn365.IActionInput {
    public productId: number;
    // TODO: Construct the input needed to run the action
    constructor(productId: number) {
        this.productId = productId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `EnhancedDescription`;
    public getCacheObjectType = () => 'ProductDescription';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetEnhancedDescriptionData {
    description: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(args);

    if (productId) {
        return new GetEnhancedDescriptionInput(+productId);
    }
    throw new Error('Unable to get Enhanced Product Input, no product Id found');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetEnhancedDescriptionInput, ctx: Msdyn365.IActionContext): Promise<IGetEnhancedDescriptionData> {
    const result = await getDescriptionByProductIdAsync({ callerContext: ctx }, input.productId);
    return { description: result?.Description || '' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetEnhancedDescriptionData>>action,
    // TODO: Give your data action a unique id
    id: 'GetEnhancedDescription',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
